import React from 'react'
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Logo from '../../Images/pari_logo_6.png'


function Navbar(props) {
  const logoSrc = Logo;
  return (
    <>
    <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      <CssBaseline />
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
      <img src={logoSrc} alt="pari" style={{width:"220px", height:"35px", paddingRight:"30px", objectFit:"contain"}}/>
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        
      </ul>

    </div>
  </div>
   </nav>
      
      </AppBar>
    </>
  )
}

export default Navbar
